import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWorkEnvironmentSurveyProgress, remindWorkEnvironmentTeam } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentSurveyProgressQueryKey = 'WORK_ENVIRONMENT_SURVEY_PROGRESS';

export const useWorkEnvironmentSurveyProgressQuery = (surveyId: number) =>
  useQuery({
    queryKey: [WorkEnvironmentSurveyProgressQueryKey, surveyId],
    queryFn: () => getWorkEnvironmentSurveyProgress(surveyId),
  });

/** The reminder responds with the new progress, so the page updates without refetching */
export const useRemindWorkEnvironmentTeamMutation = (surveyId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => remindWorkEnvironmentTeam(surveyId),
    onSuccess: (progress) => queryClient.setQueryData([WorkEnvironmentSurveyProgressQueryKey, surveyId], progress),
  });
};
